/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 *
 */

const ValidationConstants = {
  IS_CLASSIFICATION: /^[a-zA-Z]\d{0}$/,
  IS_EMAIL: /^[a-zA-Z0-9][-/*_$#+.a-zA-Z0-9]+@([-/*_$#+.a-zA-Z0-9]+\.)+[a-z]{2,10}$/,
  IS_ALPHABETIC: /^[a-zA-Z0-9\-"/+'´°()_&.,À-ž \u0370-\u03FF\u0400-\u04FF]*$/,
  IS_DIAL_CODE: /^[+0-9 ]*$/,
  IS_NUMBER: /^[-0-9 ]*$/,
  IS_SEASON_ID: /^[a-zA-Z0-9-_ ]*$/,
  IS_COUNTRY_ID: /^[a-zA-Z0-9]*$/,
  IS_SEASON_NAME: /^[a-zA-Z0-9-_()À-ž \u0370-\u03FF\u0400-\u04FF]*$/,
  IS_PASSWORD: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^"#'`[\]()+,-./:;<=>_{|}~])[A-Za-z\d@$!%*?&^"#'`[\]()+,-./:;<=>_{|}~]{6,100}$/,
  IS_BRAND_ID: /^[a-zA-Z0-9-_]*$/,
  IS_BRAND_NAME: /^[a-zA-Z0-9-_()À-ž \u0370-\u03FF\u0400-\u04FF]*$/,
};

export default ValidationConstants;
